var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { h } from "preact";
import { fontVariant } from "../../styles/index.css";
import { vpDescription } from "./Description.css";
var Description = function (_a) {
    var description = _a.description, styles = _a.styles, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.hideOnMissing, hideOnMissing = _c === void 0 ? false : _c, _d = _a.lineClamp, lineClamp = _d === void 0 ? 2 : _d, descriptionRef = _a.descriptionRef;
    var descriptionStyles = __assign({ color: styles === null || styles === void 0 ? void 0 : styles.descriptionFontColor, fontSize: styles === null || styles === void 0 ? void 0 : styles.descriptionFontSize }, (lineClamp && {
        display: "-webkit-box",
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: "vertical",
        overflow: "hidden"
    }));
    var descriptionFont = (styles === null || styles === void 0 ? void 0 : styles.descriptionFont) || '';
    if (!styles.showDescription || (hideOnMissing && !description)) {
        return null;
    }
    return (h("p", { ref: descriptionRef, className: (fontVariant === null || fontVariant === void 0 ? void 0 : fontVariant[descriptionFont]) + " " + vpDescription + " " + className, style: descriptionStyles }, description));
};
export default Description;
